import React from 'react'
import './ModalForm.sass'
import CloseButton from '../../Buttons/CloseButton/CloseButton'
import PropTypes from 'prop-types'
import AttentionGenerator from '../../Form/AttentionGenerator'
import styled from "styled-components";


const ModalForm = (props) => {

    return (
        <div onLoad={props.onload} className='formModal'>
            <div className='auth__form'>
                {props.closeHandler && <CloseButton onClick={props.closeHandler}/>}
                <div className='formModal__title'>{props.title}</div>
                <StyledAttention>
                    {props.errors ? <AttentionGenerator errors={props.errors}/> : null}
                </StyledAttention>
                {props.ready ?
                    <>
                        <div className='formModal__readyText'>{props.readyText}</div>
                        <button className='formModal__readyBtn'
                                onClick={props.closeHandler}>{props.readyBtnText}</button>
                    </> :
                    <form className='auth__login-form auth__client__login-form'>
                        {props.children}
                        <div className='form-buttons'>
                            {props.onSubmit &&
                            <button
                                disabled={props.submitDisabled}
                                className='sign-in__button'
                                onClick={props.onSubmit}>
                                {props.onSubmitTitle}
                            </button>}
                        </div>
                    </form>}
            </div>
        </div>
    )
}


ModalForm.propTypes = {
    onLoad: PropTypes.func,
    closeHandler: PropTypes.func,
    title: PropTypes.string,
    submitDisabled: PropTypes.bool,
    onSubmitTitle: PropTypes.any,
    onSubmit: PropTypes.func,
    readyText: PropTypes.string,
    readyBtnText: PropTypes.string,
    ready: PropTypes.bool

}

const StyledAttention = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 12px;
`

export default ModalForm
